import { Trans } from '@common/i18n/trans';
import { useFormContext } from 'react-hook-form';
import { Button } from '@common/ui/buttons/button';
import { DeleteIcon } from '@common/icons/material/Delete';
import { useEffect } from 'react';
import { LoanProgramAction } from './check-loan-program-action';
import { useTrans } from '@common/i18n/use-trans';
import { FormTextField } from '@common/ui/forms/input-field/text-field/text-field';
import { ReLoanProgramAction } from './re-check-uw-condition-action';
import { useRemoveItemLoanProgram } from './requests/use-remove-item-loan-program';

export function ParentRowLoanProgram({
  id,
  pidx,
  loan_product,
  removeParent,
  changeMetaHeader,
  uploadedFileItem,
}: {
  id?: number|string;
  pidx: number;
  loan_product: any;
  removeParent: any;
  changeMetaHeader: any;
  uploadedFileItem: any;
}) {
  const { trans } = useTrans();
  const { watch } = useFormContext<any>();
  const meta_header = watch(`${pidx}_meta_header`);

  useEffect(() => {
    if (meta_header) {
      changeMetaHeader(meta_header);
    }
  }, [meta_header, changeMetaHeader]);

  const removeItemLoanProgram = useRemoveItemLoanProgram(id!);

  return (
    <>
      <tr className="bg-gray-300">
        <th scope="col" className="w-[55%] bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left">
          <Trans message="Meta Header" />
        </th>
        <th scope="col" className="w-[10%] bg-sgray-300 text-md font-medium text-gray-900 px-6 py-4 text-left"></th>
        <th className="w-[15%]"></th>
      </tr>

      <tr key={`parent-row-${pidx}`} className="border-b transition duration-300 ease-in-out hover:bg-gray-100 w-[100%]">
        <td className="text-sm text-gray-900 px-6 py-4 whitespace-nowrap">
          <FormTextField
            name={`${pidx}_meta_header`}
            placeholder={trans({ message: 'Meta Header' })}
            inputElementType="textarea"
            rows={4}
            cols={60}
            className="w-250"
            onChange={e => {
              changeMetaHeader(e.target.value);
            }}
            
          >
          </FormTextField>
        </td>
        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
          <Button
            size={'xs'}
            variant="outline"
            color="red"
            onClick={() => {
              removeParent(true, pidx);
              if (id) {
                removeItemLoanProgram.mutate(
                  { id: id},
                  {
                    onSuccess: (response) => {
                      // Handle success if needed
                    },
                  }
                );
              }
            }}
            disabled={removeItemLoanProgram.isPending}
          >
            <DeleteIcon />
          </Button>
        </td>
        <td className="text-sm text-gray-900 px-6 py-4 whitespace-nowrap" colSpan={2}>
          <table className='w-full'>
            <tr className='w-full'>
              <td className='flex w-[40%]'>
                {id && uploadedFileItem ? (<>
                  <ReLoanProgramAction
                    id={id!}
                    key={`action-${id??pidx}`}
                    meta_header={meta_header}
                    files={uploadedFileItem}
                  />
                </>):(<>
                  {uploadedFileItem ? (<>
                  <LoanProgramAction
                  loan_product_id={loan_product.id}
                  key={`action-${pidx}`}
                  uploadedFileItem={uploadedFileItem}
                  meta_header={meta_header}
                />
                </>) : (<></>)}
                </>)}
              </td>
              <td className='w-[40%]'>
              </td>
              <td className='w-[20%]'></td>
            </tr>
          </table>
        </td>
      </tr>
    </>
  );
}